import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ReportsRoutes } from "./reports.routes";
import { MissingSubTitlesReportComponent } from "./missing-sub-titles-report/missing-sub-titles-report.component";
import { MissingAudiosReportComponent } from "./missing-audios-report/missing-audios-report.component";
import { GapsReportComponent } from "./gaps-report/gaps-report.component";
import { EmptyContractsReportComponent } from "./empty-contracts-report/empty-contracts-report.component";
import { ReportsService } from "../../services/reports.service";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { SchedulerAlertsReportComponent } from "./scheduler-alerts-report/scheduler-alerts-report.component";
import { AgGridModule } from "ag-grid-angular";
@NgModule({
  imports: [
    RouterModule.forRoot(ReportsRoutes, { onSameUrlNavigation: "reload" }),
    NgxDatatableModule,
    EvrideoCommonModule,
    AgGridModule,
  ],
  providers: [ReportsService],
  declarations: [
    MissingSubTitlesReportComponent,
    MissingAudiosReportComponent,
    GapsReportComponent,
    EmptyContractsReportComponent,
    SchedulerAlertsReportComponent,
  ],
  exports: [
    RouterModule,
    MissingSubTitlesReportComponent,
    MissingAudiosReportComponent,
    GapsReportComponent,
    EmptyContractsReportComponent,
  ],
})
export class ReportsModule {}
